<template>
  <nav class="left-menu">
    <v-navigation-drawer v-model="drawer" :mini-variant.sync="mini" permanent>
      <v-list-item class="px-2">
        <v-list-item-title class="admin-logo-main">
          <router-link to="/admin">
            <img
              v-if="settings && settings.icons"
              :src="showImageOrFallbackImage(settings.icons.logo)"
              class="admin-logo"
              :alt="projectName"
            />
          </router-link>
        </v-list-item-title>

        <v-btn icon @click.stop="mini = !mini">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
      </v-list-item>

      <v-divider></v-divider>
      <div class="list-items">
        <v-list>
          <template v-for="(link, i) in links">
            <v-list-item
              :key="i"
              v-if="!link.subLinks && link.can_access"
              :to="link.to"
            >
              <v-list-item-icon>
                <v-icon>{{ link.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{ link.text }}</v-list-item-title>
            </v-list-item>

            <v-list-group
              :prepend-icon="link.icon"
              :key="i"
              v-if="link.subLinks && link.can_access"
            >
              <template v-slot:activator>
                <v-list-item-title>{{ link.text }}</v-list-item-title>
              </template>

              <template v-for="(sublink, i) in link.subLinks">
                <v-list-item
                  v-if="sublink.can_access"
                  :key="`sublink${i}`"
                  link
                  :to="sublink.to"
                >
                  <v-list-item-icon>
                    <v-icon
                      v-if="mini === true && !sublink.icon"
                      style="font-size: 18px"
                    >
                      {{ getFirstLetter(sublink.text) }}
                    </v-icon>
                    <v-icon
                      v-if="mini === true && sublink.icon"
                      style="font-size: 18px"
                    >
                      {{ sublink.icon }}
                    </v-icon>
                  </v-list-item-icon>
                  <v-list-item-title
                    v-text="sublink.text"
                    class="d-flex sub-menu"
                  ></v-list-item-title>
                </v-list-item>
              </template>
            </v-list-group>
          </template>
        </v-list>
      </div>
      <div class="bottom-menu">
        <hr />
        <v-list>
          <v-list-item>
            <v-list-item-icon>
              <div v-if="userProfile && userProfile.avatar" class="avatar-menu">
                <img :src="userProfile.avatar" :alt="userProfile.avatar" />
              </div>
              <v-icon v-else>mdi-account-circle</v-icon>
            </v-list-item-icon>
            <v-list-item-title>
              {{ userProfile ? userProfile.name : null }}
            </v-list-item-title>
          </v-list-item>
          <v-list-item @click="signOut()">
            <v-list-item-icon>
              <v-icon>mdi-logout</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Cerrar sesión</v-list-item-title>
          </v-list-item>
        </v-list>
      </div>
    </v-navigation-drawer>
  </nav>
</template>

<script>
import { groupOrdersCollection } from "@/collections/groupOrders";

export default {
  name: "navbar",
  props: ["currentUser"],
  data() {
    return {
      drawer: true,
      mini: false,
      groupOrders: []
    };
  },
  firestore() {
    return {
      groupOrders: groupOrdersCollection.where("active", "==", true)
    };
  },
  computed: {
    userProfile() {
      return this.$store.state.userProfile;
    },
    hasRoleOwner() {
      return this.$store.getters.hasRoleOwner;
    },
    hasRoleManager() {
      return this.$store.getters.hasRoleManager;
    },
    hasRoleWaiter() {
      return this.$store.getters.hasRoleWaiter;
    },
    pedidosSubLinks() {
      return this.groupOrders.map(link => {
        return {
          icon: "mdi-food",
          text: `${link.name}`,
          to: `/admin/orders-group/${link.id}`,
          can_access:
            this.hasRoleOwner || this.hasRoleManager || this.hasRoleWaiter
        };
      });
    },
    links() {
      const hasRoleOwner = this.hasRoleOwner;
      const hasRoleManager = this.hasRoleManager;
      const hasRoleWaiter = this.hasRoleWaiter;

      return [
        {
          icon: "mdi-view-dashboard",
          text: "Dashboard",
          can_access: hasRoleOwner,
          subLinks: [
            {
              icon: "mdi-receipt",
              text: "Principal",
              to: "/admin/dashboard/principal",
              can_access: hasRoleOwner
            },
            {
              icon: "mdi-receipt",
              text: "Rankings",
              to: "/admin/dashboard/rankings",
              can_access: hasRoleOwner
            }
          ]
        },
        {
          icon: "mdi-cart",
          text: "Pedidos",
          can_access: hasRoleOwner || hasRoleManager || hasRoleWaiter,
          subLinks: [
            {
              icon: "mdi-receipt",
              text: "Crear Pedido",
              to: "/admin/orders/create-order",
              can_access: hasRoleOwner || hasRoleManager || hasRoleWaiter
            },
            ...this.pedidosSubLinks,
            {
              icon: "mdi-paper-roll-outline",
              text: "Cuentas abiertas",
              to: "/admin/orders-open/list",
              can_access: hasRoleOwner || hasRoleManager || hasRoleWaiter
            },
            {
              icon: "mdi-receipt",
              text: "Cierres de caja (Z)",
              to: "/admin/orders/cierres-de-caja-z",
              can_access: hasRoleOwner || hasRoleManager
            },
            {
              icon: "mdi-history",
              text: "Historial de Pedidos",
              to: "/admin/orders/history",
              can_access: hasRoleOwner || hasRoleManager || hasRoleWaiter
            },
            {
              icon: "mdi-credit-card-settings-outline",
              text: "Historial de Pagos",
              to: "/admin/orders/payment-history",
              can_access: hasRoleOwner || hasRoleManager
            }
          ]
        },
        {
          icon: "mdi-silverware-fork-knife",
          text: "Productos",
          can_access: hasRoleOwner || hasRoleManager,
          subLinks: [
            {
              icon: "mdi-playlist-edit",
              text: "Listado",
              to: "/admin/products/list",
              can_access: hasRoleOwner || hasRoleManager
            },
            {
              icon: "mdi-clipboard-list",
              text: "Categorías",
              to: "/admin/products/categories",
              can_access: hasRoleOwner
            },
            {
              icon: "mdi-clipboard-list-outline",
              text: "Subcategorías",
              to: "/admin/products/subcategories",
              can_access: hasRoleOwner
            },
            {
              icon: "mdi-notebook-edit-outline",
              text: "Orden Cartas",
              to: "/admin/menus/order-cartas",
              can_access: hasRoleOwner || hasRoleManager
            },
            {
              icon: "mdi-notebook-edit-outline",
              text: "Cartas",
              to: "/admin/menus/cartas",
              can_access: hasRoleOwner || hasRoleManager
            },
            {
              icon: "mdi-clipboard-edit-outline",
              text: "Menus",
              to: "/admin/menus/menu-group",
              can_access: hasRoleOwner || hasRoleManager
            },
            {
              icon: "mdi-clipboard-list-outline",
              text: "Grupo de pedidos",
              to: "/admin/products/group-orders",
              can_access: hasRoleOwner
            }
          ]
        },
        {
          icon: "mdi-clock-time-four-outline",
          can_access: hasRoleOwner || hasRoleManager,
          text: "Horarios",
          subLinks: [
            {
              icon: "mdi-clock-time-four-outline",
              text: "Cartas Principales",
              to: "/admin/schedule/main",
              can_access: hasRoleOwner || hasRoleManager
            },
            {
              icon: "mdi-clock-time-four-outline",
              text: "Cartas",
              to: "/admin/schedule/menu",
              can_access: hasRoleOwner || hasRoleManager
            },
            {
              icon: "mdi-clock-time-four-outline",
              text: "Menus",
              to: "/admin/schedule/menu-group",
              can_access: hasRoleOwner || hasRoleManager
            }
          ]
        },
        {
          icon: "mdi-qrcode",
          text: "Mesa QR",
          can_access: hasRoleOwner || hasRoleManager,
          subLinks: [
            {
              icon: "mdi-playlist-edit",
              text: "Listado",
              to: "/admin/tables-qr/list",
              can_access: hasRoleOwner || hasRoleManager
            },
            {
              icon: "mdi-playlist-edit",
              text: "Zona de Mesas QR",
              to: "/admin/tables-qr/zones",
              can_access: hasRoleOwner || hasRoleManager
            },
            {
              icon: "mdi-playlist-edit",
              text: "Generador de QR",
              to: "/admin/tables-qr/generate-qr",
              can_access: hasRoleOwner || hasRoleManager
            }
          ]
        },
        {
          icon: "mdi-account-group",
          text: "Usuarios",
          can_access: hasRoleOwner,
          subLinks: [
            {
              icon: "mdi-account-supervisor",
              text: "Administradores",
              to: "/admin/users/list",
              can_access: hasRoleOwner
            }
          ]
        },
        {
          icon: "mdi-printer",
          text: "Impresoras",
          can_access: hasRoleOwner,
          subLinks: [
            {
              icon: "mdi-playlist-edit",
              text: "Listado",
              to: "/admin/printers/list",
              can_access: hasRoleOwner
            },
            {
              icon: "mdi-clipboard-list-outline",
              text: "Rutas de impresión",
              to: "/admin/printers/printing-routes",
              can_access: hasRoleOwner
            },
            {
              icon: "mdi-clipboard-list-outline",
              text: "Apertura de Cajón",
              to: "/admin/printers/cash-drawers",
              can_access: hasRoleOwner
            }
          ]
        },
        {
          icon: "mdi-google-translate",
          text: "Traducciones",
          can_access: hasRoleOwner || hasRoleManager,
          subLinks: [
            {
              text: "Bebida",
              to: "/admin/translate/drink",
              can_access: hasRoleOwner || hasRoleManager
            },
            {
              text: "Comida",
              to: "/admin/translate/food",
              can_access: hasRoleOwner || hasRoleManager
            },
            {
              text: "Postres",
              to: "/admin/translate/dessert",
              can_access: hasRoleOwner || hasRoleManager
            },
            {
              text: "Categorías",
              to: "/admin/translate/category",
              can_access: hasRoleOwner || hasRoleManager
            },
            {
              text: "Subcategorías",
              to: "/admin/translate/subcategory",
              can_access: hasRoleOwner || hasRoleManager
            },
            {
              text: "Cartas",
              to: "/admin/translate/cartas",
              can_access: hasRoleOwner || hasRoleManager
            },
            {
              text: "Menús",
              to: "/admin/translate/menus",
              can_access: hasRoleOwner || hasRoleManager
            }
          ]
        },
        {
          icon: "mdi-cog-outline",
          text: "Settings",
          can_access: hasRoleOwner,
          subLinks: [
            {
              icon: "mdi-cogs",
              text: "Configuración",
              to: "/admin/settings/config",
              can_access: hasRoleOwner
            },
            {
              icon: "mdi-information-outline",
              text: "Información de la Empresa",
              to: "/admin/settings/info",
              can_access: hasRoleOwner
            },
            {
              icon: "mdi-image",
              text: "Imágenes",
              to: "/admin/settings/images",
              can_access: hasRoleOwner
            },
            {
              icon: "mdi-image",
              text: "Plantilla y Colores",
              to: "/admin/settings/theme",
              can_access: hasRoleOwner
            },
            {
              text: "Envío de Email",
              to: "/admin/settings/send-email",
              icon: "mdi-email",
              can_access: hasRoleOwner
            },
            {
              icon: "mdi-backup-restore",
              text: "Mantenimiento",
              to: "/admin/settings/maintenance",
              can_access: hasRoleOwner
            }
          ]
        },
        {
          icon: "mdi-math-log",
          text: "Logs",
          can_access: hasRoleOwner,
          subLinks: [
            {
              icon: "mdi-list-status",
              text: "Historial de Logs",
              to: "/admin/logs/history",
              can_access: hasRoleOwner
            },
            {
              icon: "mdi-printer-check",
              text: "Historial de Impresión",
              to: "/admin/logs/printer-history",
              can_access: hasRoleOwner
            },
            {
              icon: "mdi-printer-alert",
              text: "Errores de Impresión",
              to: "/admin/logs/printer-errors",
              can_access: hasRoleOwner
            }
          ]
        }
      ];
    }
  },
  watch: {
    mini() {
      const body = document.body;
      if (this.mini) {
        body.classList.add("close-nav-bar");
        body.classList.remove("open-nav-bar");
      } else {
        body.classList.add("open-nav-bar");
        body.classList.remove("close-nav-bar");
      }
    }
  },
  methods: {
    signOut() {
      this.$emit("signOut");
    }
  }
};
</script>
<style scoped>
.avatar-menu {
  width: 24px;
  height: 24px;
  overflow: hidden;
  border-radius: 50%;
}

.avatar-menu img {
  max-width: 100%;
  height: 100%;
  object-fit: cover;
}

.v-application .primary--text {
  color: #000 !important;
  caret-color: #000 !important;
}

.left-menu .v-list-item__title {
  width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block !important;
}
</style>
